import PageLoadedQueue from "../PageLoadedQueue";

class RecentlyViewed {

    constructor() {
    }

    static async addRecent() {

        const addToListUrl = new URL(articleViewData.uri, window.location.href);

        const response = await fetch(addToListUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                article: articleViewData.node
            })
        });
    }

    static initialize() {
        //todo: add articleViewedIdentifier to list
        if (typeof articleViewData !== 'undefined') {
            setTimeout(() => {
                // only track view after 2 seconds to avoid spam of articles when quickly checking multiple
                RecentlyViewed.addRecent();
            }, 2000);
        }
    }
}

PageLoadedQueue.addFunction(RecentlyViewed.initialize);
